import { HomeMenuSubItemPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubItemPopout";
import { SubjectsMenuPopoutSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenuPopoutSection";

const HomeMenuSubjectsPopout = ({ onClickBack }: IHomeMenuSubjectsPopout) => {
  return (
    <HomeMenuSubItemPopout
      dataTestId="home-subjects-popout"
      onClickBack={onClickBack}
    >
      <SubjectsMenuPopoutSection />
    </HomeMenuSubItemPopout>
  );
};

interface IHomeMenuSubjectsPopout {
  onClickBack: () => void;
}

HomeMenuSubjectsPopout.displayName = "HomeMenuSubjectsPopout";
export { HomeMenuSubjectsPopout };
